// extracted by mini-css-extract-plugin
module.exports = {"label":"fIfmB","uppercase":"COg58","monserrat":"naJ9h","nunito":"VR7cM","block":"_0Bxhb"};